import React from "react"
import {Modal} from "antd"
import cx from "classnames"
import {Icon} from "components/Icon"
import styles from "./popup.module.css"

export function BasePopup(props) {
    const {isShow, onClose, children, className, leftIcon, leftIconColor, ...rest} = props

    return (
        <Modal
            visible={isShow}
            onCancel={onClose}
            width="90vw"
            closeIcon={<Icon icon="CLOSE" color="#000" className={styles.closeIcon} />}
            maskClosable={false}
            footer={null}
            centered
            className={cx("base-popup", className || "")}
            {...rest}>
            <div className={styles.dialogWrap}>
                <div className={styles.leftSide}>
                    <Icon
                        icon={leftIcon ? leftIcon : "UNORDER_LIST"}
                        className={styles.leftSideIcon}
                        color={leftIconColor || "#fff"}
                    />
                </div>
                <div className={styles.dialogContent}>{children}</div>
            </div>
        </Modal>
    )
}
